import React from 'react'
import './index.less'
import Flex from '../Flex'

type RowHeaderProps = {
    title: React.ReactNode
    style?: React.CSSProperties
    className?: string
}

const RowHeader: React.FC<RowHeaderProps> = (props) => {

    const { title, style, className } = props

    return (
        <Flex gap={10} style={style} className={className} justify='left' align='center'>
            <span style={{ width: '2px', height: '14px', background: '#1677ff', borderRadius: '2px' }}></span>
            <span style={{ color: '#333333', fontWeight: '600', fontSize: '14px' }}>{title}</span>
        </Flex>
    )
}

export default RowHeader